import httpRequest from '../../utils/request';

const register = async (user) => {
  const response = await httpRequest.post('/auth/register', user);
  return response.data;
};

const login = async (user) => {
  // Si hay pista de tenant en localStorage, incluirla para desambiguar logins con emails repetidos
  let payload = { ...user };
  try {
    const tid = localStorage.getItem('VENTIO_FORCE_TENANT');
    if (tid) payload.tenantId = tid; // Solo respetar el forzado explícito en login
  } catch (_) {}
  const response = await httpRequest.post('/auth/login', payload);
  return response.data;
};

const logout = async () => {
  // Llamar al backend para borrar la cookie HttpOnly de sesión
  try {
    await httpRequest.post('/auth/logout');
  } catch (_) { /* ignorar errores de red para no bloquear el flujo de logout */ }
  return Promise.resolve();
};

const allUsers = async () => {
  const response = await httpRequest.get('/auth/users');
  return response.data;
};

const authService = {
  register,
  login,
  logout,
  allUsers,
};

export default authService;
